import React from 'react';

import { Grid } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

import grandma3 from '../assets/grandma3.jpg';
import grandma3M from '../assets/grandma3M.jpg';
import grandma4 from '../assets/grandma4.jpg';
import grandma4M from '../assets/grandma4M.jpg';
import computerLady3 from '../assets/computerLady3.jpg';
import computerLady3M from '../assets/computerLady3M.jpg';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    marginTop: '6.5rem',
    [theme.breakpoints.down('sm')]: {
      marginTop: '2.5rem'
    }
  },
  col1: {
    width: '50%',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  halfPhoto: {
    width: '100%'
  }
}));

const PhotoCollage1 = () => {
  const classes = useStyles();
  const theme = useTheme();
  const matchesSM = useMediaQuery(theme.breakpoints.down('sm'));
  const { ref, inView } = useInView({ triggerOnce: true });

  const renderer = (
    <Grid container className={classes.imgCont}>
      <Grid container direction="column" className={classes.col1}>
        <motion.img
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 2, delay: 0.4 } }}
          src={matchesSM ? grandma3M : grandma3}
          alt="grandma on phone"
          className={classes.halfPhoto}
        />
        <motion.img
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 2, delay: 1 } }}
          src={matchesSM ? computerLady3M : computerLady3}
          alt="grandma on phone"
          className={classes.halfPhoto}
        />
      </Grid>
      <Grid container direction="column" className={classes.col1}>
        <Grid item>
          <motion.img
            initial={{ opacity: 0 }}
            animate={{ opacity: 1, transition: { duration: 2, delay: 1.6 } }}
            src={matchesSM ? grandma4M : grandma4}
            alt="grandma on phone"
            className={classes.halfPhoto}
          />
        </Grid>
      </Grid>
    </Grid>
  );

  return (
    <Grid ref={ref} container className={classes.wrapper}>
      {inView ? renderer : null}
    </Grid>
  );
};

export default PhotoCollage1;
